import React from 'react';

function CircularProgress() {
  return (
    <div className="omi-loading-page">
      <div className="loader">Loading...</div>
      {/* <p>Chúng tôi đang thiết lập dữ liệu cho bạn.</p>
    <p>Bạn vui lòng đợi trong giây lát nhé!</p>
    <img src={loader} alt="loader" /> */}
    </div>
  );
}

export default CircularProgress;
